import { render } from "./BasicInformationCard.vue?vue&type=template&id=08ee7332&scoped=true"
import script from "./BasicInformationCard.vue?vue&type=script&lang=js"
export * from "./BasicInformationCard.vue?vue&type=script&lang=js"

import "./BasicInformationCard.vue?vue&type=style&index=0&id=08ee7332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ee7332"]])

export default __exports__